import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select'];

  select(event) {
    window.location.href = event.target.value;
  }
}
